import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux'

// components
import JobHistoryList from "./_list";
import { showLoader } from "../../../components/loader/loader";

// actions
import { ADD_STATE, REMOVE_STATE } from "../../../redux/actions/generics/IndexedActions";

//utils
import {getStateByPath} from "../../../redux/selectors";



const JobHistory = props => {
    const path = 'configuration/jobHistory'; // TODO: Change this path
    const componentState = useSelector(state => getStateByPath(state, path));
    const {loading} = componentState?.data || false;

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    return <>
        {loading && showLoader()}
        { componentState && <JobHistoryList path={path} /> }
    </>
}


const mapStateToProps = state => ({})
const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
})

export default connect(mapStateToProps, mapActionsToProps)(JobHistory)